import { useState } from 'react';
import { faqData } from '@/mocks/brand';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            关于爱液网页版，你可能想了解的问题都在这里
          </p>
        </div>

        <div className="max-w-2xl mx-auto flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                <i
                  className={`text-lg text-foreground-500 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}